import { render } from "./HorseColorForm.vue?vue&type=template&id=686ad6c6"
import script from "./HorseColorForm.vue?vue&type=script&lang=js"
export * from "./HorseColorForm.vue?vue&type=script&lang=js"

import "./HorseColorForm.vue?vue&type=style&index=0&id=686ad6c6&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__